import { datadogRum } from '@datadog/browser-rum';
import { identify } from '@side/analytics';
import { useSession } from '@side/next-auth/react';
import { useEffect } from 'react';

export function AnalyticsIdentify() {
  const { data: session } = useSession();
  const user = session?.user;

  useEffect(() => {
    if (user?.id) {
      const { email, displayName, firstName, lastName, id, photoUrl } = user;
      // Track user in Side Analytics
      void identify(id, { email, name: displayName, avatar: photoUrl });

      // Track user in Datadog RUM
      datadogRum.setUser({
        email: email ?? undefined,
        name: displayName ?? `${firstName} ${lastName}`,
        id,
      });
    }
  }, [user]);

  return null;
}
